import styled from "styled-components";
import { useDispatch } from "react-redux";
import { exitMember } from "Features/api/api";

const ExitForm = ({ setIsExitModalOpen, user, selectedMember, totalUserContributions, balanceSheetData, users_shared_interest_data, userCount }) => {
  const dispatch = useDispatch();

  const nonClearedLoans = selectedMember.loans?.filter(
    loan => loan.status === 'active' || loan.status === 'default'
  ) || [];

  const totalNonClearedLoans = nonClearedLoans.reduce(
    (acc, loan) => acc + Number(loan.current_balance || 0), 
    0
  );

  const retainedEarnings = Number((-1 * (balanceSheetData?.equities?.retained_earnings?.balance || 0)).toFixed(2));

  const overallSharedInterest = user.has_cleared
    ? 0
    : Number(
        balanceSheetData?.users_shared_interest_data
          ? balanceSheetData.users_shared_interest_data
          : (userCount > 0 ? retainedEarnings / userCount : 0)
      );

  const userSharedInterest = users_shared_interest_data?.find(
    data => data.user === user.id
  );

  const balance = userSharedInterest
    ? Number((-1 * (userSharedInterest.balance || 0)).toFixed(2))
    : 0;
const actualSharedInterest = Number(
  (
    userSharedInterest
      ? balance * 0.63
      : overallSharedInterest * 0.63
  ).toFixed(2)
);
    console.log("real", actualSharedInterest)

  const handleSubmitExit = () => {
    const exitData = {
      member_id: selectedMember.id,
      non_cleared_loans: nonClearedLoans,
      total_contributions: Number(selectedMember.total_contributions || 0),
      overall_shared_interest: Number(balance.toFixed(2)),
      
      actual_shared_interest: actualSharedInterest,
    };
    console.log('Processing exit for:', exitData);
    dispatch(exitMember(exitData));
    setIsExitModalOpen(false);
  };
console.log("real", actualSharedInterest)
  return (
    <ExitFormL>
      <h3>Confirm Exit</h3>
      <p>Please confirm the exit of this member:</p>
      <p><strong>Name:</strong> {`${selectedMember.first_name} ${selectedMember.last_name}`}</p>
      <p><strong>Member ID:</strong> {selectedMember.id}</p>
      <p><strong>Total Contributions:</strong> {totalUserContributions}</p>
      <p><strong>Overall Shared Interest:</strong> {userSharedInterest ? balance : overallSharedInterest}</p>
      <p><strong>Actual Shared Interest:</strong> {actualSharedInterest}</p>
      <strong>Non-Cleared Loans:</strong>
      <ul>
        {nonClearedLoans.length > 0 ? (
          nonClearedLoans.map((loan, index) => (
            <li key={index}>
              <p><strong>Principal:</strong> {loan.amount}</p>
              <p><strong>Current Balance:</strong> {Number(loan.current_balance || 0).toFixed(2)}</p>
              <p><strong>Start Date:</strong> {loan.start_date}</p>
              <p><strong>Expiry Date:</strong> {loan.expiry_date}</p>
              <p><strong>Status:</strong> {loan.status}</p>
            </li>
          ))
        ) : (
          <p>No non-cleared loans.</p>
        )}
      </ul>
      <button onClick={handleSubmitExit}>Confirm Exit</button>
    </ExitFormL>
  );
};

const ExitFormL = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  p {
    margin: 5px 0;
  }
  button {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #e2725b;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
`;

export default ExitForm;
